import SmoothScroll from 'smooth-scroll';

export default function init() {
    // All animations will take exactly 500ms
    let scroll = new SmoothScroll('a[href*="#"]', {
        speed: 500,
        speedAsDuration: true
    });
}
